import { render, staticRenderFns } from "./addTax.vue?vue&type=template&id=0a84b1f2"
import script from "./addTax.vue?vue&type=script&lang=js"
export * from "./addTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports